import { render, staticRenderFns } from "./InboxArchive.vue?vue&type=template&id=2737b31e"
import script from "./InboxArchive.vue?vue&type=script&lang=js"
export * from "./InboxArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports